var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 0.666016C12.3655 0.666193 12.665 0.96645 12.665 1.33301V1.99902H13.332C14.0654 1.99902 14.665 2.59967 14.665 3.33301V13.999C14.665 14.7324 14.0654 15.333 13.332 15.333H2.66504C1.93185 15.3328 1.33203 14.7322 1.33203 13.999V3.33301C1.33203 2.59978 1.93185 1.9992 2.66504 1.99902H3.33203V1.33301C3.33203 0.966341 3.63236 0.666016 3.99902 0.666016C4.36554 0.666193 4.66504 0.96645 4.66504 1.33301V1.99902H11.332V1.33301C11.332 0.966341 11.6324 0.666016 11.999 0.666016ZM2.66504 5.33301V13.333C2.66522 13.6995 2.96547 13.999 3.33203 13.999H12.665C13.0316 13.999 13.3319 13.6995 13.332 13.333V5.33301H2.66504Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.086da1baff5e9813a6380270e4b1e360.svg";
export { ForwardRef as ReactComponent };